import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import CustomSpan from 'components/common/text/CustomSpan';
import { isClinicUserSelector } from 'store/modules/user';
import { useShallowAppSelector } from 'store/hooks';
import { ISystemSetting, ISystemSettingCode } from 'lib/types/userTypes';
import SystemSettingListContainer from './SystemSettingListContainer';
import { freedom_i_horizontal } from 'components/base/images';
import ScanIosSettingContainer from './ScanIosSettingContainer';

interface SystemSettingModalContainerProps {
  onCloseModal: () => void;
}

function SystemSettingModalContainer({ onCloseModal }: SystemSettingModalContainerProps) {
  const {
    isClinicUser,
  }: {
    isClinicUser: boolean;
  } = useShallowAppSelector(state => ({
    isClinicUser: isClinicUserSelector(state),
  }));
  const { ipcRenderer } = window;

  const [current, setCurrent] = useState<ISystemSettingCode>('LIST');
  const [selectedMachine, setSelectedMachine] = useState<ISystemSetting | null>(null);
  const [installedList, setInstalledList] = useState<string[]>([]);

  const handleClickSystem = (item: ISystemSetting) => {
    setSelectedMachine(item);
    setCurrent(item.code);
  };

  const handleClickGoBack = () => {
    setCurrent('LIST');
  };

  const machineSettingList = [
    {
      img: freedom_i_horizontal,
      code: 'APP_SCAN_IOS',
      textCode: 'MACHINE_SCAN_IOS',
      recovery: 'SCAN_IOS_RECOVERY',
      backup: 'SCAN_IOS_BACKUP',
      component: (
        <ScanIosSettingContainer data={selectedMachine} onClickGoBack={handleClickGoBack} />
      ),
    },
  ];

  const contentsList = [
    {
      code: 'LIST',
      component: (
        <SystemSettingListContainer
          machineSettingList={machineSettingList}
          onClick={handleClickSystem}
        />
      ),
    },
    ...machineSettingList,
  ];

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.send('installedAppList', {});
    }
  }, []);

  useEffect(() => {
    if (ipcRenderer) {
      ipcRenderer.on('installedAppListRes', (e: any, data: any) => {
        data.appList.map((appCode: string) => {
          const findData = contentsList.find((item: ISystemSetting) => item.code === appCode)?.code;
          if (!!findData) {
            setInstalledList([...installedList, findData]);
          }
        });
      });
    }
  }, []);

  return (
    <StyledSystemSettingModal data-component-name="SystemSettingModal">
      {installedList.length > 0 ? (
        contentsList.find((item: ISystemSetting) => item.code == current)?.component
      ) : (
        <div className="systemSettingModal__empty_box">
          <CustomSpan>
            <T>SYSTEM_SET_SOFTWARE_PATH</T>
          </CustomSpan>
        </div>
      )}
    </StyledSystemSettingModal>
  );
}
const StyledSystemSettingModal = styled.div<{}>`
  width: 100%;
  height: 640px;
  border-radius: 15px;
  padding: 30px;
  background-color: #ffffff;
  position: relative;
  .systemSettingModal__empty_box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export default React.memo(SystemSettingModalContainer);
